import { Injectable, NgZone } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ErpTrackingInitialState, ErpTrackingItemLoad } from './erp-tracking-item.actions';
import { ErpTrackingItemService } from './erp-tracking-item.service';
import { Error, CustomHttpErrorResponse, NotificationService } from '../../../../common';
import { DeliveryNoteErpView } from '../models/erp-tracking.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

type ErpTrackingStateModel = {
  item: DeliveryNoteErpView;
  loaded: boolean;
};

const initialState: ErpTrackingStateModel = {
  item: null,
  loaded: false,
};

@State<ErpTrackingStateModel>({
  name: 'erpTracking',
  defaults: initialState,
})
@Injectable()
export class ErpTrackingItemState {
  constructor(
    private erpTrackingSearchItemService: ErpTrackingItemService,
    private notificationService: NotificationService,
    private ngZone: NgZone,
  ) {}

  @Selector()
  static getItem(state: ErpTrackingStateModel): DeliveryNoteErpView {
    return state.item;
  }

  @Selector()
  static getLoaded(state: ErpTrackingStateModel): boolean {
    return state.loaded;
  }

  @Action(ErpTrackingItemLoad)
  getItem(
    ctx: StateContext<ErpTrackingStateModel>,
    { payload }: ErpTrackingItemLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    const { deliveryNoteNumber, orderNumber, salesOrganization } = payload;

    return this.erpTrackingSearchItemService.getItem({ deliveryNoteNumber, orderNumber, salesOrganization }).pipe(
      map((deliveryNote: DeliveryNoteErpView) => {
        this.ngZone.run(() => {
          ctx.patchState({ item: deliveryNote, loaded: true });
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => {
        ctx.patchState({ loaded: true });
        return of(this.notificationService.error(error.message));
      }),
    );
  }

  @Action(ErpTrackingInitialState)
  setInitialState(ctx: StateContext<ErpTrackingStateModel>): void {
    ctx.setState(initialState);
  }
}
